export default "__VITE_ASSET__3e703b3f__"